import React, { useEffect, useState } from "react";
import "./ProfileSetup.scss";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../uiComponents/ProfileSetup/Sidebar/Sidebar";
import StepOne from "../../uiComponents/ProfileSetup/Steps/StepOne";
import StepTwo from "../../uiComponents/ProfileSetup/Steps/StepTwo";
import StepThree from "../../uiComponents/ProfileSetup/Steps/StepThree";
import { isMobile } from "react-device-detect";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { selectCities, selectCityLoader } from "../updateProfile/redux/slice";
import Loader from "../../uiComponents/loader/Loader";
import { Typography } from "antd";
import { APIV3 } from "../../utils/customAxios";
import { Box, CircularProgress } from "@mui/material";
import Cookies from "js-cookie";
import { useEffectOnce } from "react-use";
import StepFour from "../../uiComponents/ProfileSetup/Steps/StepFour";
import { ToastContainer } from "react-toastify";

const ProfileSetup = (props) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [about, setAbout] = useState(true);
  const [qualification, setQualification] = useState(false);
  const [consultation, setConsultation] = useState(false);
  const [profileVerification, setProfileVerification] = useState(false);
  const [progress, setProgress] = useState("");
  const [percentage, setPercentage] = useState(null);
  const [listner, setListner] = useState(false);
  const [image, setImage] = useState();
  const cities = useAppSelector(selectCities);
  const citiesLoading = useAppSelector(selectCityLoader);
  const [savedImage, setSavedImage] = useState("");

  const dispatch = useAppDispatch();
  const moveToQualification = () => {
    setAbout(false);
    setQualification(true);
  };

  const moveToConsultation = () => {
    setQualification(false);
    setConsultation(true);
  };

  const moveToProfileVerification = () => {
    setConsultation(false);
    setProfileVerification(true);
  };
  const totalSteps = 3;

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const fetchProgress = async () => {
    try {
      const response = await APIV3.get(`doctor/progress`);
      if (response?.status == 200) {
        setProgress(response?.data?.data);
        setPercentage(
          parseInt(response?.data?.data?.profile_completion_percentage)
        );
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchProgress();
  }, [listner]);

  useEffectOnce(() => {
    const cookeiGet = Cookies.get("pageStatus");
    if (cookeiGet === "qualifications") {
      setAbout(false);
      setQualification(true);
      setConsultation(false);
    } else if (cookeiGet === "consultation") {
      setAbout(false);
      setQualification(false);
      setConsultation(true);
    } else if (cookeiGet === "profileVerification") {
      setAbout(false);
      setConsultation(false);
      setProfileVerification(true);
    }
  }, [JSON.stringify(Cookies.get("pageStatus"))]);
  return (
    <>
      {citiesLoading && <Loader />}
      <section
        className={`pt-120 ${isMobile ? "pb-130 " : ""} progressbar ${
          qualification ? "progressbar50" : ""
        } ${consultation ? "progressbar75" : ""}`}
      >
        <Container fluid>
          <Row className="z-index-relative">
            {!isMobile && (
              <>
                <Col md={3} lg={3} className="zeind">
                  <div className="sidebar_profile">
                    <div className="complate_profile pt-40 pb-30">
                      <div className="chart_style text-center pb-3">
                        <div class="single-chart custom-progress position-relative">
                          <Box position="relative" display="inline-flex">
                            <CircularProgress
                              style={{
                                width: "128px",
                                height: "128px",
                                borderRadius: "100%",
                                boxShadow:
                                  "rgba(15, 52, 90, 0.20) 0px 0px 0px 1px inset",
                                backgroundColor: "transparent",
                                color: "#19B3B5",
                              }}
                              size={80}
                              thickness={1}
                              value={percentage}
                              variant="determinate"
                            />

                            <Box
                              top={25}
                              left={20}
                              bottom={0}
                              right={0}
                              position="absolute"
                              display="block"
                              alignItems="center"
                              justifyContent="center"
                              className="progressBox"
                            >
                              <Typography
                                style={{ fontSize: "22px", color: "#000000" }}
                                variant="caption"
                                component="div"
                                color="textSecondary"
                              >
                                {percentage} %
                              </Typography>
                            </Box>
                          </Box>

                          <div className="drImage">
                            {/* <img src={drimage01}></img> */}
                            {image ? (
                              <img
                                src={URL.createObjectURL(image)}
                                alt="uploaded preview"
                                style={{
                                  width: 100,
                                  height: 100,
                                  objectFit: "cover",
                                  borderRadius: '50%'
                                }}
                              />
                            ) : savedImage ? (
                              <img
                                src={savedImage}
                                alt="backend preview"
                                style={{
                                  width: 100,
                                  height: 100,
                                  objectFit: "cover",
                                  borderRadius: '50%'
                                }}
                              />
                            ) : (
                              <span className="drAvatarSv"></span>
                            )}
                          </div>
                        </div>
                        <h6>
                          {progress?.profile_completion_percentage} Profile
                          Completed
                        </h6>
                      </div>
                    </div>
                    <Sidebar progress={progress} />
                  </div>
                </Col>
              </>
            )}
            <Col md={9} lg={9} xs={12} className={!isMobile ? "ps-0" : ""}>
              <div>
                {/* {isMobile ? (
                  <MobileSteps
                    setListner={setListner}
                    moveToQualification={moveToQualification}
                    moveToConsultation={moveToConsultation}
                  />
                ) : ( */}
                <>
                  <div className="main_step_box pd-main">
                    {about && (
                      <>
                        <h2>Profile</h2>
                        <StepOne
                          setListner={setListner}
                          moveToQualification={moveToQualification}
                          setAbout={setAbout}
                          setConsultation={setConsultation}
                          setQualification={setQualification}
                          setImage={setImage}
                          image={image}
                          savedImage={savedImage}
                          setSavedImage={setSavedImage}
                        />
                      </>
                    )}
                    {qualification && (
                      <>
                        <h2>Qualification</h2>
                        <StepTwo
                          setListner={setListner}
                          setAbout={setAbout}
                          setConsultation={setConsultation}
                          setQualification={setQualification}
                          moveToConsultation={moveToConsultation}
                        />
                      </>
                    )}
                    {consultation && (
                      <>
                        <h2>Consultation Details</h2>
                        <StepThree
                          setListner={setListner}
                          setConsultation={setConsultation}
                          setQualification={setQualification}
                          setProfileVerification={setProfileVerification}
                          profileVerification={profileVerification}
                        />
                      </>
                    )}
                    {profileVerification && (
                      <>
                        <h2>Profile Verification</h2>
                        <StepFour
                          setListner={setListner}
                          moveToProfileVerification={moveToProfileVerification}
                          setProfileVerification={setProfileVerification}
                          setConsultation={setConsultation}
                        />
                      </>
                    )}
                  </div>
                </>
                {/* )} */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <ToastContainer />
    </>
  );
};

export default ProfileSetup;
